import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start gap-1" }

import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { CheckValidationStatus } from '@/Network/Types/Responses/CheckValidationResponses'

import {
  EDITED_SINCE_SUBMIT_BADGE,
  EVIDENCE_UNAVAILABLE_BADGE,
  OVERDUE_BADGE,
  statusConfigFor
} from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckValidationStatusBadge',
  props: {
    status: {},
    isOverdue: { type: Boolean, default: false },
    isEditedSinceSubmit: { type: Boolean, default: false },
    isEvidenceUnavailable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const statusConfig = computed(() => statusConfigFor(props.status))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LabelBadge, {
      label: statusConfig.value.label,
      color: statusConfig.value.color,
      icon: statusConfig.value.icon,
      size: "small",
      "data-testid": "check-validation-status-badge"
    }, null, 8, ["label", "color", "icon"]),
    (_ctx.isOverdue)
      ? (_openBlock(), _createBlock(LabelBadge, {
          key: 0,
          label: _unref(OVERDUE_BADGE).label,
          color: _unref(OVERDUE_BADGE).color,
          icon: _unref(OVERDUE_BADGE).icon,
          size: "small",
          "data-testid": "check-validation-overdue-badge"
        }, null, 8, ["label", "color", "icon"]))
      : _createCommentVNode("", true),
    (_ctx.isEditedSinceSubmit)
      ? (_openBlock(), _createBlock(LabelBadge, {
          key: 1,
          label: _unref(EDITED_SINCE_SUBMIT_BADGE).label,
          color: _unref(EDITED_SINCE_SUBMIT_BADGE).color,
          icon: _unref(EDITED_SINCE_SUBMIT_BADGE).icon,
          size: "small",
          "data-testid": "check-validation-edited-badge"
        }, null, 8, ["label", "color", "icon"]))
      : _createCommentVNode("", true),
    (_ctx.isEvidenceUnavailable)
      ? (_openBlock(), _createBlock(LabelBadge, {
          key: 2,
          label: _unref(EVIDENCE_UNAVAILABLE_BADGE).label,
          color: _unref(EVIDENCE_UNAVAILABLE_BADGE).color,
          icon: _unref(EVIDENCE_UNAVAILABLE_BADGE).icon,
          size: "small",
          "data-testid": "check-validation-evidence-unavailable-badge"
        }, null, 8, ["label", "color", "icon"]))
      : _createCommentVNode("", true)
  ]))
}
}

})